var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00009 13.5C4.27624 13.5 4.50009 13.7239 4.50009 14V16.2044L6.24105 17.1619C6.48301 17.295 6.57128 17.599 6.4382 17.841C6.30512 18.0829 6.00109 18.1712 5.75913 18.0381L3.75913 16.9381C3.59936 16.8502 3.50009 16.6823 3.50009 16.5V14C3.50009 13.7239 3.72395 13.5 4.00009 13.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4382 6.15894C6.57128 6.4009 6.48301 6.70493 6.24105 6.83801L4.50009 7.79554V9.9999C4.50009 10.276 4.27624 10.4999 4.00009 10.4999C3.72395 10.4999 3.50009 10.276 3.50009 9.9999V7.4999C3.50009 7.31756 3.59936 7.14967 3.75913 7.06179L5.75913 5.96179C6.00109 5.82872 6.30512 5.91698 6.4382 6.15894Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7591 2.56189C11.9092 2.47937 12.091 2.47937 12.2411 2.56189L14.2411 3.66189C14.483 3.79497 14.5713 4.099 14.4382 4.34096C14.3051 4.58292 14.0011 4.67119 13.7591 4.53811L12.0001 3.57064L10.2411 4.53811C9.99909 4.67119 9.69506 4.58292 9.56198 4.34096C9.42891 4.099 9.51717 3.79497 9.75913 3.66189L11.7591 2.56189Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.562 6.15894C17.6951 5.91698 17.9991 5.82872 18.2411 5.96179L20.2411 7.06179C20.4008 7.14967 20.5001 7.31756 20.5001 7.4999V9.9999C20.5001 10.276 20.2762 10.4999 20.0001 10.4999C19.724 10.4999 19.5001 10.276 19.5001 9.9999V7.79554L17.7591 6.83801C17.5172 6.70493 17.4289 6.4009 17.562 6.15894Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 13.5C20.2762 13.5 20.5001 13.7239 20.5001 14V16.5C20.5001 16.681 20.4023 16.8478 20.2444 16.9363L18.2444 18.0563C18.0035 18.1912 17.6988 18.1052 17.5638 17.8643C17.4289 17.6234 17.5149 17.3187 17.7558 17.1837L19.5001 16.2069V14C19.5001 13.7239 19.724 13.5 20.0001 13.5Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56198 19.6589C9.69506 19.417 9.99909 19.3287 10.2411 19.4618L12.0001 20.4293L13.7591 19.4618C14.0011 19.3287 14.3051 19.417 14.4382 19.6589C14.5713 19.9009 14.483 20.2049 14.2411 20.338L12.2411 21.438C12.091 21.5205 11.9092 21.5205 11.7591 21.438L9.75913 20.338C9.51717 20.2049 9.42891 19.9009 9.56198 19.6589Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4382 10.6589C14.5713 10.9009 14.483 11.2049 14.2411 11.338L12.2411 12.438C11.9991 12.5711 11.6951 12.4828 11.562 12.2409C11.4289 11.9989 11.5172 11.6949 11.7591 11.5618L13.7591 10.4618C14.0011 10.3287 14.3051 10.417 14.4382 10.6589Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4382 7.25904C20.5713 7.501 20.483 7.80503 20.2411 7.93811L18.2411 9.03811C17.9991 9.17119 17.6951 9.08292 17.562 8.84096C17.4289 8.599 17.5172 8.29497 17.7591 8.16189L19.7591 7.06189C20.0011 6.92881 20.3051 7.01708 20.4382 7.25904Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 11.5C12.2762 11.5 12.5001 11.7239 12.5001 12V14.5C12.5001 14.7761 12.2762 15 12.0001 15C11.724 15 11.5001 14.7761 11.5001 14.5V12C11.5001 11.7239 11.724 11.5 12.0001 11.5Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 18C12.2762 18 12.5001 18.2239 12.5001 18.5V21C12.5001 21.2761 12.2762 21.5 12.0001 21.5C11.724 21.5 11.5001 21.2761 11.5001 21V18.5C11.5001 18.2239 11.724 18 12.0001 18Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56384 10.6356C9.69876 10.3946 10.0035 10.3087 10.2444 10.4436L12.2444 11.5636C12.4853 11.6986 12.5713 12.0032 12.4363 12.2442C12.3014 12.4851 11.9967 12.5711 11.7558 12.4361L9.75579 11.3161C9.51486 11.1812 9.42892 10.8765 9.56384 10.6356Z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56199 7.25904C3.69506 7.01708 3.99909 6.92881 4.24105 7.06189L6.24105 8.16189C6.48301 8.29497 6.57128 8.599 6.4382 8.84096C6.30512 9.08292 6.00109 9.17119 5.75913 9.03811L3.75913 7.93811C3.51717 7.80503 3.42891 7.501 3.56199 7.25904Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.22e5f0b309e8cd019fe9620b60ff7d2f.svg";
export { ForwardRef as ReactComponent };